import React from "react";
import { object, string } from "prop-types";

import SectionName from "../../atoms/section-name";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import "./special-story-header.m.css";

const SpecialStoryHeader = ({ sectionName, story }) => {
  return (
    <div styleName="wrapper">
      <div styleName="content">
        <SectionName name={sectionName} />
        <Headline text={story.headline} headerType={12} headerLevel={1} />
        <Headline text={story.subheadline} headerType={11} headerLevel={2} />
      </div>
      <CardImage story={story} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" />
      <div styleName="figure-caption">
        {story["hero-image-attribution"] && (
          <span styleName="image-attribute"> {story["hero-image-attribution"]} </span>
        )}
        {story["hero-image-caption"] && <span styleName="image-caption">{story["hero-image-caption"]} </span>}
      </div>
    </div>
  );
};

SpecialStoryHeader.propTypes = {
  story: object,
  sectionName: string
};

export default SpecialStoryHeader;
